module.exports = __webpack_public_path__ + "static/media/agriculture@2x.5f8e04bd.png";